import React from 'react';
import Image from '../../../components/AppImage';

const SpiritualBackground = () => {
  return (
    <div className="fixed inset-0 z-0">
      {/* Full Background Image */}
      <div
        className="absolute inset-0 w-full h-full bg-cover bg-left"
        style={{
          backgroundImage: 'url(/assets/images/sai-background.jpg)',
          // opacity: 0.70,
        
        }}
      />
      {/* Enhanced Background Gradient with Better Contrast */}
      <div className="absolute inset-0 bg-gradient-to-br from-white via-spiritual-light to-spiritual-orange/5" />
      <div className="absolute inset-0 bg-gradient-to-br from-spiritual-blue/5 via-transparent to-spiritual-purple/5" />
      
      {/* Subtle Pattern Overlay */}
      {/*
      <div className="absolute inset-0 opacity-3">
        <div className="w-full h-full bg-repeat" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23FF8A00' fill-opacity='0.08'%3E%3Cpath d='M30 30l15-15v30l-15-15zm-15 0l15 15H0l15-15z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          backgroundSize: '60px 60px'
        }} />
      </div>
      */}

      {/* Main Sathya Sai Baba Sarvadharma Symbol - Centered and Prominent */}
      {/*
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="relative w-96 h-96 md:w-[28rem] md:h-[28rem] lg:w-[32rem] lg:h-[32rem] opacity-15">
          <div className="absolute inset-0 bg-spiritual-divine/10 rounded-full blur-3xl" />
          <div className="relative w-full h-full rounded-full overflow-hidden">
            <Image
              src="/assets/images/sai-background.jpg"
              alt="Sathya Sai Baba with Sarvadharma Symbol"
              className="w-full h-full object-cover object-center"
              fallback="/assets/images/no_image.png"
            />
          </div>
          <div className="absolute inset-0 rounded-full border-4 border-spiritual-gold/20" />
        </div>
      </div>
      */}

      {/* Decorative Floating Elements - Reduced Opacity */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-16 left-16 w-3 h-3 bg-spiritual-gold/30 rounded-full spiritual-float opacity-40" />
        <div className="absolute top-24 right-24 w-2 h-2 bg-spiritual-blue/30 rounded-full spiritual-float opacity-30" style={{animationDelay: '0.5s'}} />
        <div className="absolute bottom-40 left-24 w-4 h-4 bg-spiritual-purple/30 rounded-full spiritual-float opacity-25" style={{animationDelay: '1s'}} />
        <div className="absolute bottom-24 right-40 w-2 h-2 bg-spiritual-rose/30 rounded-full spiritual-float opacity-35" style={{animationDelay: '1.5s'}} />
        <div className="absolute top-1/2 left-20 w-2 h-2 bg-spiritual-teal/30 rounded-full spiritual-float opacity-30" style={{animationDelay: '2s'}} />
        <div className="absolute top-1/3 right-28 w-3 h-3 bg-spiritual-amber/30 rounded-full spiritual-float opacity-35" style={{animationDelay: '2.5s'}} />
      </div>

      {/* Corner Decorative Elements - Subtle */}
      <div className="absolute top-8 left-8 opacity-15">
        <div className="w-12 h-12 border-2 border-spiritual-blue/30 rounded-full flex items-center justify-center spiritual-float">
          <div className="w-6 h-6 bg-spiritual-blue/20 rounded-full" />
        </div>
      </div>

      <div className="absolute bottom-1/4 left-8 opacity-15">
        <div className="w-10 h-10 border-2 border-spiritual-purple/30 transform rotate-45 spiritual-float" style={{animationDelay: '1s'}} />
      </div>

      <div className="absolute top-1/3 right-16 opacity-15">
        <div className="w-16 h-16 border-2 border-spiritual-teal/30 rounded-full spiritual-float" style={{animationDelay: '0.5s'}} />
      </div>

      {/* Subtle Divine Light Rays */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-1 h-24 bg-spiritual-divine/5 rotate-12" />
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-1 h-24 bg-spiritual-divine/5 rotate-45" />
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-1 h-24 bg-spiritual-divine/5 rotate-75" />
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-1 h-24 bg-spiritual-divine/5 -rotate-12" />
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-1 h-24 bg-spiritual-divine/5 -rotate-45" />
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-1 h-24 bg-spiritual-divine/5 -rotate-75" />

      {/* Enhanced Sarvadharma Symbol in Corner */}
      <div className="absolute bottom-8 right-8 opacity-12">
        <div className="w-20 h-20 md:w-24 md:h-24 spiritual-float">
          <svg
            viewBox="0 0 100 100"
            className="w-full h-full"
            fill="none"
          >
            {/* Lotus Petals with Religious Symbols */}
            {/* <circle cx="50" cy="50" r="40" fill="none" stroke="url(#rainbow-gradient)" strokeWidth="2" />
            <path d="M50 10 L58 35 L85 35 L68 55 L75 85 L50 68 L25 85 L32 55 L15 35 L42 35 Z" fill="url(#rainbow-gradient)" opacity="0.6" />
            <circle cx="50" cy="50" r="6" fill="url(#divine-gradient)" /> */}
            
            {/* Religious Symbols in Petals */}
            {/* <text x="50" y="25" textAnchor="middle" fontSize="8" fill="url(#gold-gradient)">ॐ</text>
            <text x="70" y="55" textAnchor="middle" fontSize="8" fill="url(#gold-gradient)">✝</text>
            <text x="50" y="80" textAnchor="middle" fontSize="8" fill="url(#gold-gradient)">☪</text>
            <text x="30" y="55" textAnchor="middle" fontSize="8" fill="url(#gold-gradient)">☸</text> */}
            
            <defs>
              <linearGradient id="rainbow-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#FF8A00" />
                <stop offset="25%" stopColor="#2196F3" />
                <stop offset="50%" stopColor="#9C27B0" />
                <stop offset="75%" stopColor="#FFD700" />
                <stop offset="100%" stopColor="#FF5722" />
              </linearGradient>
              <linearGradient id="divine-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#9C27B0" />
                <stop offset="50%" stopColor="#FFD700" />
                <stop offset="100%" stopColor="#FF8A00" />
              </linearGradient>
              <linearGradient id="gold-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#FFD700" />
                <stop offset="100%" stopColor="#FFA726" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default SpiritualBackground;